module.exports = __webpack_public_path__ + "img/oti_1.81956087.jpg";